import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userReducer, { logout } from "./slices/userSlice";
import announcementsReducer from "./slices/announcementsSlice";
import categoriesReducer from "./slices/categoriesSlice";
import serversReducer from "./slices/serverSlice";
import adminUsersReducer from "./slices/adminUsersSlice";

const rootReducer = combineReducers({
  user: userReducer,
  announcements: announcementsReducer,
  categories: categoriesReducer,
  servers: serversReducer,
  adminUsers: adminUsersReducer,
});

// Build preloaded state synchronously from localStorage so components
// read correct auth state on first render.
let preloadedState = {};
try {
  const raw = localStorage.getItem("auth");
  if (raw) {
    const parsed = JSON.parse(raw);
    const { token, user, roles, role, expiresAt } = parsed;
    if (token && (!expiresAt || new Date(expiresAt).getTime() > Date.now())) {
      preloadedState.user = {
        token,
        user,
        roles: roles || [],
        role: role || null,
        expiresAt: expiresAt || null,
        isAuthenticated: true,
      };
    } else {
      localStorage.removeItem("auth");
      localStorage.removeItem("userId");
    }
  }
} catch (e) {
  // ignore
}

export const store = configureStore({
  reducer: rootReducer,
  preloadedState,
});

// If we have an expiresAt, schedule automatic logout
try {
  const expiresAt = preloadedState.user?.expiresAt;
  if (expiresAt) {
    const ms = new Date(expiresAt).getTime() - Date.now();
    if (ms > 0) {
      setTimeout(() => {
        localStorage.removeItem("auth");
        localStorage.removeItem("userId");
        store.dispatch(logout());
      }, ms);
    } else {
      // already expired
      localStorage.removeItem("auth");
      localStorage.removeItem("userId");
      store.dispatch(logout());
    }
  }
} catch (e) {
  // ignore
}

export default store;
